module.exports = __webpack_public_path__ + "static/img/banner.351bac47.png";